import React, { useState, useEffect } from "react";
import { useRef } from "react";
import { useNavigate } from "react-router-dom";
import SideBar from "../../components/sidebar";
import Header from "../../components/header";
import "../../assets/CSS/dashboard.css";
import "../../assets/CSS/forms.css";
import ProjectTable from "../../components/projectTable";
import API_BASE_URL from "../../config";
import "../../assets/CSS/loader.css";

function ProjectEntry() {
  const navigate = useNavigate();
  const formRef = useRef();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loader, setLoader] = useState(false);
  const [divisionQuery, setDivisionQuery] = useState("");
  const [divisionOptions, setDivisionOptions] = useState([]);
  const [rangeQuery, setRangeQuery] = useState("");
  const [rangeOptions, setRangeOptions] = useState([]);
  const [reload, setReload] = useState(0);

  useEffect(() => {
    if (!divisionQuery) {
      setDivisionOptions([]);
      return;
    }

    const delayDebounce = setTimeout(() => {
      fetch(`${API_BASE_URL}/api/division-options?query=${divisionQuery}`)
        .then((res) => res.json())
        .then((data) => {
          setDivisionOptions(data.divisions.map((d) => d.name));
        })
        .catch((err) => console.error("Error fetching:", err));
    }, 400);

    return () => clearTimeout(delayDebounce);
  }, [divisionQuery]);

  useEffect(() => {
    if (!rangeQuery) {
      setRangeOptions([]);
      return;
    }

    const delayDebounce = setTimeout(() => {
      fetch(`${API_BASE_URL}/api/range-options?query=${rangeQuery}`)
        .then((res) => res.json())
        .then((data) => {
          setRangeOptions(data.ranges.map((d) => d.name));
        })
        .catch((err) => console.error("Error fetching:", err));
    }, 400);

    return () => clearTimeout(delayDebounce);
  }, [rangeQuery]);

  const handleSubmit = async (e) => {
    setLoader(true);
    e.preventDefault();
    setIsSubmitting(true);

    if (!formRef.current.checkValidity()) {
      formRef.current.reportValidity();
      setIsSubmitting(false);
      setLoader(false);
      return;
    }

    const formData = new FormData(formRef.current);

    try {
      const response = await fetch(API_BASE_URL + "/api/project-master", {
        method: "POST",
        body: formData,
      });

      const result = await response.json();

      if (response.ok) {
        alert("Project added successfully");
        formRef.current.reset();
        setIsSubmitting(false);
        setLoader(false);
        setReload((prev) => prev + 1);
      } else {
        alert(result.error || "Error uploading data");
        setIsSubmitting(false);
        setLoader(false);
      }
    } catch (error) {
      console.error(error);
      alert("Server error");
      setIsSubmitting(false);
      setLoader(false);
    }
  };

  return (
    <div>
      {loader && (
        <div className="loader">
          <div className="loader-spinner"></div>
        </div>
      )}
      <SideBar />
      <div className="main-content">
        <Header />
        <div id="form-content">
          <div id="form-header">
            <p>Project Master</p>
          </div>
          <hr />
          <form id="form" ref={formRef}>
            <div id="form-input">
              <label htmlFor="name">
                Project Name<span className="required">*</span>
              </label>
              <input
                type="text"
                name="name"
                id="name"
                placeholder="Enter Project Name"
                required
              />
            </div>
            <div id="form-input">
              <label htmlFor="initial">
                Project Initial (User Agency)<span className="required">*</span>
              </label>
              <input
                type="text"
                name="initial"
                id="initial"
                placeholder="Enter Project Initial"
                required
              />
            </div>
            <div id="form-input">
              <label htmlFor="division">
                Project Division<span className="required">*</span>
              </label>
              <input
                type="text"
                name="division"
                id="division"
                placeholder="Select Project Division"
                list="division-options"
                value={divisionQuery}
                onChange={(e) => setDivisionQuery(e.target.value)}
                autoComplete="off"
                required
              />
              <datalist id="division-options">
                {divisionOptions.map((option, index) => (
                  <option key={index} value={option} />
                ))}
              </datalist>
            </div>
            <div id="form-input">
              <label htmlFor="range">
                Project Range<span className="required">*</span>
              </label>
              <input
                type="text"
                name="range"
                id="range"
                placeholder="Select Project Range"
                list="range-options"
                value={rangeQuery}
                onChange={(e) => setRangeQuery(e.target.value)}
                autoComplete="off"
                required
              />
              <datalist id="range-options">
                {rangeOptions.map((option, index) => (
                  <option key={index} value={option} />
                ))}
              </datalist>
            </div>
            <div id="form-input">
              <label htmlFor="start-date">
                Project Start Date<span className="required">*</span>
              </label>
              <input type="date" name="start-date" id="start-date" required />
            </div>
            <div id="form-input">
              <label htmlFor="end-date">
                Project End Date<span className="required">*</span>
              </label>
              <input type="date" name="end-date" id="end-date" required />
            </div>
            <div id="form-input">
              <label htmlFor="status">
                Project Status<span className="required">*</span>
              </label>
              <select name="status" id="status" required>
                <option value="" disabled>
                  Select Project Status<span className="required">*</span>
                </option>
                <option value="Running">Running</option>
                <option value="Pending">Pending</option>
                <option value="Closed">Closed</option>
              </select>
            </div>
          </form>
          <div className="button">
            <button
              type="button"
              className="btn"
              id="submit"
              onClick={handleSubmit}
              disabled={isSubmitting}
            >
              SUBMIT
            </button>
          </div>
        </div>
        <ProjectTable reload={reload} />
      </div>
    </div>
  );
}

export default ProjectEntry;
